import { useState } from 'react';
import { Grid, TextField, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { DatePicker } from '@mui/x-date-pickers-pro';
import { datePickerFormat } from 'helpers';
import { EstateResultItem_OneViewEmploymentInput } from 'queries';

type Props = {
  // eslint-disable-next-line @typescript-eslint/ban-types
  setEssentialData: Function;
};

const useStyles = makeStyles(() => ({
  container: {
    paddingTop: '10px',
  },
  inputField: {
    textAlign: 'left',
    width: '100%',
  },
  dateField: {
    paddingTop: '10px',
    textAlign: 'left',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  datePicker: {
    padding: '5px',
  },
  title: {
    paddingTop: '10px',
  },
}));

export default function AddEmploymentItem({ setEssentialData }: Props) {
  const classes = useStyles();

  const [employmentInput] = useState<EstateResultItem_OneViewEmploymentInput>({
    employer: 'Unknown Employer',
    identifier: '',
    startDate: '',
    endDate: '',
  });

  const [selectedStartDate, setSelectedStartDate] = useState<Date>();
  const [selectedEndDate, setSelectedEndDate] = useState<Date>();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleInputChange = (e: any) => {
    const name: string = e.target.name;
    employmentInput[name as keyof EstateResultItem_OneViewEmploymentInput] = e.target.value;
    setEssentialData(employmentInput);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleDateInputChange = (e: any, name: string) => {
    const date = new Date(e);
    const formattedDate = `${date.getMonth() + 1 < 10 ? '0' : ''}${date.getMonth() + 1}/${
      date.getDate() < 10 ? '0' : ''
    }${date.getDate()}/${date.getFullYear()}`;
    employmentInput[name as keyof EstateResultItem_OneViewEmploymentInput] = formattedDate;
    if (name === 'startDate') {
      setSelectedStartDate(e);
    } else {
      setSelectedEndDate(e);
    }
    setEssentialData(employmentInput);
  };

  return (
    <>
      <Typography variant="h5" className={classes.title}>
        Add Employment History
      </Typography>
      <Grid className={classes.container}>
        <Grid className={classes.inputField}>
          <TextField
            className={classes.inputField}
            fullWidth
            name="employer"
            label="Employer"
            variant="outlined"
            onChange={handleInputChange}
            inputProps={{ maxLength: 30 }}
          />
        </Grid>
        <Grid className={classes.container}>
          <Grid className={classes.inputField}>
            <TextField
              className={classes.inputField}
              fullWidth
              name="identifier"
              label="Identifier (Current / Former)"
              variant="outlined"
              onChange={handleInputChange}
              inputProps={{ maxLength: 30 }}
            />
          </Grid>
        </Grid>
        <Grid className={classes.dateField}>
          <Grid className={classes.datePicker} item xs={12} sm={6}>
            <Typography variant="caption">Start Date</Typography>
            <DatePicker
              orientation="landscape"
              value={selectedStartDate}
              maxDate={selectedEndDate}
              onChange={(e) => handleDateInputChange(e, 'startDate')}
              format={datePickerFormat}
              className={classes.inputField}
            />
          </Grid>
          <Grid className={classes.datePicker} item xs={12} sm={6}>
            <Typography variant="caption">End Date</Typography>
            <DatePicker
              orientation="landscape"
              value={selectedEndDate}
              minDate={selectedStartDate}
              onChange={(e) => handleDateInputChange(e, 'endDate')}
              format={datePickerFormat}
              className={classes.inputField}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
